<template>
  <section class="bg-white">
    <div class="lightblue-bg">
      <div class="about-proven">
        <div class="text-center">
          <div class="contents">
            <h2 class="mx-lg-5 px-lg-5">
              JORNAY PM has been proven to provide all-day symptom support.
            </h2>

            <img src="@/assets/images/3_25/about/check-mark.svg" alt="CheckMark" />

            <p class="dark-text">
              JORNAY PM demonstrated significant symptom support in 2 clinical
              <br class="d-none d-lg-block" />studies of children with ADHD, aged 6
              to 12&nbsp;years.
            </p>

            <img src="@/assets/images/3_25/about/check-mark.svg" alt="CheckMark" />

            <p class="dark-text proven-text-list">
              Symptoms of ADHD were evaluated using standard and novel validated
              assessment <span class="text-nowrap">tools—the</span> same tools or tests a doctor might
              <span class="text-nowrap"
                >use—throughout</span
              >
              the day to measure all-day ADHD symptom support.
            </p>

            <p class="mb-0">
              You can learn more about the 
              <RouterLink to="/safety" class="fw-semibold"
                >safety and side effects of JORNAY PM here</RouterLink
              >.
            </p>

            <!-- <br />
            <p class="dark-text mb-0 mt-lg-2">
              Some of the most common side effects in both studies were trouble
              <br class="d-none d-lg-block" />sleeping, nausea, decreased appetite,
              mood swings, restlessness, vomiting, and headache. Talk to your
              healthcare provider if you experience these or other side effects
              while taking <span class="no-wrap">JORNAY PM</span>.
            </p> -->
          </div>
        </div>
      </div>
    </div>  
  </section>
</template>

<script>
export default {
  name: "AboutProven",
};
</script>
